import { render, staticRenderFns } from "./PlanoTrabalho.vue?vue&type=template&id=754c81fa&scoped=true"
import script from "./PlanoTrabalho.vue?vue&type=script&lang=js"
export * from "./PlanoTrabalho.vue?vue&type=script&lang=js"
import style0 from "./PlanoTrabalho.vue?vue&type=style&index=0&id=754c81fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754c81fa",
  null
  
)

export default component.exports